// Firebase configuration for Network Management App
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAnut3MQHRY5HiyrnEQdpdqjXiIYUmxXiI",
  authDomain: "elp-networking-tool.firebaseapp.com",
  projectId: "elp-networking-tool",
  storageBucket: "elp-networking-tool.firebasestorage.app",
  messagingSenderId: "608901614348",
  appId: "1:608901614348:web:aa4fa19b5442f047bf1729",
  measurementId: "G-PE8HEJX4TC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
